module.exports = __webpack_public_path__ + "img/ROI Icon.01f780c4.svg";